import RichiesteAccessoComponent from "../../components/RichiesteAccesso/RichiestaCredenzialiAccesso/RichiesteAccessoComponent";

export default function RichiesteAcesso() {

    return (
        <RichiesteAccessoComponent></RichiesteAccessoComponent>
    )
}